<template>
  <div>
  <div v-if="showAnimation">
    <v-row >
      <v-col cols="12">
        <v-card max-width="3000" max-height="400" color="primary darken-1">
          <div style="height: 400px;">
            <LoadingAnimation @loopComplete="loadAnimationComplete" />
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
  <div v-else>
    <v-row class="align-center justify-center white--text hidden-sm-and-down">
      <v-col cols="12" sm="6" md="6" align-self="start" align="start" class="justify-start align-start">
        <strong>Dados hidrológicos</strong>
      </v-col>
      <v-spacer />
      <v-col cols="12" sm="6" md="6" align-self="end" align="end" class="justify-end align-end">
        <strong>Dados de precipitação na bacia de contribuição</strong>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6" class="hidden-md-and-up">
        <strong>Dados hidrológicos</strong>
      </v-col>
      <v-col cols="12">
        <precipitation-data-contribution-basin-cards
          :volume="volume"
          :usefulStorage="usefulStorage"
          :currentQuota="currentQuota"
          :accumulatedRainOfMonth="accumulatedRainOfMonth"
          :currentMonth="currentMonth"
          :reservoirSelected="reservoirSelected"
        />
      </v-col>
    </v-row>
    <v-row justify="center" align="center" class="mt-4">
      <v-col>
        <hydrological-data-cards
          :affluentFlow="affluentFlow"
          :tendency="tendency"
          :accumulatedOfLastThirtyDays="accumulatedOfLastThirtyDays"
          :climatographicAverage="climatographicAverage"
          :sensorData="sensor351Data"
          :rulerImageInfo="rulerImageInfo"
          :showReservoirRuler="false"
        />
      </v-col>
    </v-row>
    <v-row class="hidden-md-and-up">
      <!-- mobile and tablet -->
      <v-col cols="12" sm="6" md="6">
        <strong>Dados de precipitação na bacia de contribuição</strong>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <v-card class="primary darken-1 last">
          <v-row class="ml-1" v-if="accumulatedRainOfMonth">
            <v-col cols="12" class="ml-0 mr-2">
              <v-icon style="color: lightgrey" left small>restore</v-icon>
              <span style="color: lightgrey; font-size: small">Atualizado em {{ accumulatedRainOfMonth.updated }}</span>
            </v-col>
          </v-row>
          <v-card-title class="mt-n5">
            <v-icon color="secondary" class="mb-2">
              mdi-weather-pouring
            </v-icon>
          </v-card-title>
          <v-card-subtitle class="font-weight-bold white--text">Chuva do mês atual</v-card-subtitle>
          <v-card-text>
            <v-row v-if="typeof accumulatedRainOfMonth === 'undefined'">
              <v-col cols="3">
                <v-icon color="orange" right>mdi-information-outline</v-icon>
              </v-col>
              <v-spacer/>
              <v-col cols="9">
                <span style="color: orange">Os dados de chuva do mês atual estão indisponíveis no momento.</span>
              </v-col>
            </v-row>
            <v-row v-else class="white--text">
              <v-col cols="12">
                <strong class="display-1 font-weight-bold">
                  <span v-if="typeof accumulatedRainOfMonth.value === 'number'"> {{ accumulatedRainOfMonth.value.toFixed(1) }} </span>
                  <span v-else>{{ accumulatedRainOfMonth.value }}</span>
                  <span class="font-weight-thin title">mm
                    <span class="subtitle-1"> Acumulado do mês de {{ currentMonth }}</span>
                  </span>
                </strong>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" sm="4" md="2">
        <v-card class="primary darken-1 default">
          <v-row class="align-start justify-start ml-2 mr-2" v-if="accumulatedOfLastThirtyDays">
            <v-col cols="1">
              <v-icon style="color: lightgrey" left small>restore</v-icon>
            </v-col>
            <v-col cols="10">
              <span style="color: lightgrey; font-size: small">Atualizado em {{ accumulatedOfLastThirtyDays.updated }}</span>
            </v-col>
          </v-row>
          <v-card-title class="mt-n5">
            <v-icon color="secondary" class="mb-2">
              mdi-weather-pouring
            </v-icon>
          </v-card-title>
          <v-card-subtitle class="font-weight-bold white--text">Chuva dos últimos 30 dias</v-card-subtitle>
          <v-card-text>
            <v-row v-if="typeof accumulatedOfLastThirtyDays === 'undefined'">
              <v-col cols="3">
                <v-icon color="orange" right>mdi-information-outline</v-icon>
              </v-col>
              <v-spacer/>
              <v-col cols="9">
                <span style="color: orange">Os dados de chuva dos últimos 30 dias estão indisponíveis no momento.</span>
              </v-col>
            </v-row>
            <v-row v-else class="white--text">
              <v-col cols="12">
                <strong class="display-1 font-weight-bold">
                  <span v-if="typeof accumulatedOfLastThirtyDays.value === 'number'"> {{ accumulatedOfLastThirtyDays.value.toFixed(1) }} </span>
                  <span v-else>{{ accumulatedOfLastThirtyDays.value }}</span>
                  <span class="font-weight-thin title">mm</span>
                </strong>
              </v-col>
              <v-col cols="12">
                <span>Acumulado dos últimos 30 dias</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" sm="4" md="2">
        <v-card class="primary darken-1 default">
          <v-row class="align-start justify-start ml-2 mr-2" v-if="!climatographicAverage">
            <v-col cols="1">
              <v-icon style="color: lightgrey" left small>restore</v-icon>
            </v-col>
            <v-col cols="10">
              <span style="color: lightgrey; font-size: small">Atualizado em ##/##/####</span>
            </v-col>
          </v-row>
          <v-row v-else class="align-start justify-start ml-2 mr-2">
            <v-col cols="1">
              <v-icon style="color: lightgrey" left small>restore</v-icon>
            </v-col>
            <v-col cols="10">
              <span style="color: lightgrey; font-size: small">Atualizado em {{ climatographicAverage.updated }}</span>
            </v-col>
          </v-row>
          <v-card-title class="mt-n5">
            <v-icon color="secondary" class="mb-2">
              mdi-weather-pouring
            </v-icon>
          </v-card-title>
          <v-card-subtitle class="font-weight-bold white--text">Média climatológica</v-card-subtitle>
          <v-card-text>
            <v-row v-if="!climatographicAverage">
              <v-col cols="3">
                <v-icon color="orange" right>mdi-information-outline</v-icon>
              </v-col>
              <v-spacer/>
              <v-col cols="9">
                <span style="color: orange">Os dados de média climatológica estão indisponíveis no momento.</span>
              </v-col>
            </v-row>
            <v-row v-else class="white--text">
              <v-col cols="12">
                <strong class="display-1 font-weight-bold">
                  {{ climatographicAverage.value.toFixed(1) }} <span class="font-weight-thin title mt-5">mm</span>
                </strong>
              </v-col>
              <v-col cols="12">
                <span>Média de 1979 - {{ climatographicAverage.year }} do mês de {{ climatographicAverage.month }}</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
  </div>
</template>

<script>
import HydrologicalDataCards from "./HydrologicalDataCards";
import PrecipitationDataContributionBasinCards from "./PrecipitationDataContributionBasinCards";
import moment from "moment";
import LoadingAnimation from "../common/LoadingAnimation";
import { loadDailySummary } from "@/api/telemetry/daily-summary.api";
export default {
  name: "WaterSupplyHydrologicalDataReservoirs",
  props:['reservoirSelected'],
  components: {LoadingAnimation, PrecipitationDataContributionBasinCards, HydrologicalDataCards},
  data(){
    return{
      currentMonth: moment().locale('pt-br').format('MMMM'),
      loading: false,
      showAnimation: false,
      affluentFlow: undefined,
      tendency: undefined,
      accumulatedRainOfMonth: undefined,
      accumulatedOfLastThirtyDays: undefined,
      climatographicAverage: undefined,
      currentQuota: undefined,
      volume: undefined,
      usefulStorage: undefined,
      sensor351Data: undefined,
      rulerImageInfo: undefined,
    }
  },
  watch:{
    reservoirSelected(value){
      if(value){ this.initialize() }
    },
  },
  mounted() {
    this.initialize()
  },
  methods:{
    async initialize(){
      this.loading = true
      this.showAnimation = true

      const promises = [
        this.$store.dispatch('loadVolume', {
          date_start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
          date_end: moment().format('YYYY-MM-DD'),
          operation_ids: '1',
          sensor_ids: '294',
          sort: 'desc',
          station_ids: this.reservoirSelected.codigo,
        }),
        this.loadUsefulStorage(),
        this.$store.dispatch('loadCurrentQuota', {
          date_start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
          date_end: moment().format('YYYY-MM-DD'),
          operation_ids: 1,
          sensor_ids: 18,
          sort: 'desc',
          station_ids: this.reservoirSelected.codigo,
        }),
        this.$store.dispatch('loadClimatographicAverage', {
          month: moment().tz('America/Sao_Paulo').format('MM'),
          year: moment().tz('America/Sao_Paulo').format('YYYY'),
          variable: 'prec',
          location_id: this.reservoirSelected.locationid,
        }),
        this.$store.dispatch('loadAffluentFlowForecast', {
          type: 'daily',
          source: '2',
          location_id: this.reservoirSelected.locationid,
          runtime: moment().utc().startOf("day").format(),
        }),
        this.$store.dispatch('loadReservoirTendency', {
          datai: moment().subtract(2, 'days').format('YYYY-MM-DD'),
          dataf: moment().subtract(1, 'days').format('YYYY-MM-DD'),
          estacoes: this.reservoirSelected.codigo,
          sensores: '294',
          operacoes: '1',
        }),
        this.$store.dispatch('loadAccumulatedRainCurrentMonth', {
          startDate: moment().startOf('month').format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
          locationIds: [this.reservoirSelected.locationid],
        }),
        this.$store.dispatch('loadAccumulatedRainOfTheLastThirtyDays', {
          startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
          endDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
          locationIds: [this.reservoirSelected.locationid],
        })
      ];

      await Promise.all(promises);

      //volume
      let volume = this.$store.getters.volume;

      // cópia: formatar direto no objeto do store faz um segundo initialize() reler "DD/MM/YYYY" como "YYYY-MM-DD" (ano 2028)
      if (volume && volume.length > 0) {
        volume = volume[0];
        if (volume.data) {
          this.volume = { ...volume, data: moment(volume.data, 'YYYY-MM-DD').tz('America/Sao_Paulo').format('DD/MM/YYYY') };
        }
      } else {
        this.volume = null;
      }

      //volume
      //current quota
      let currentQuota = this.$store.getters.currentQuota;
      currentQuota = currentQuota[0];
      this.currentQuota = currentQuota;

      //current quota
      //climatographic average
      let climatographicAverage = this.$store.getters.climatographicAverage[0];
      if(climatographicAverage) {
        climatographicAverage.updated = climatographicAverage ? moment(climatographicAverage.updated).tz('America/Sao_Paulo').format('DD/MM/YYYY'): '##/##/####';
        climatographicAverage.month =  climatographicAverage ? moment(climatographicAverage.month, 'DD/MM/YYY').locale('pt-br').format('MMMM') : '';
        this.climatographicAverage = climatographicAverage;
      }

      //climatographic average
      //affluent
      let affluent = this.$store.getters.affluentFlowForecast[0]
      if(affluent){
        affluent.value[0].updated = this.$store.getters.affluentFlowForecast[0] ? moment(affluent.updated).tz('America/Sao_Paulo').format('DD/MM/YYYYTHH:mm') : '##/##/####';
        this.affluentFlow = affluent.value[0];
      }

      //affluent
      //tendency
      let reservoirTendency = this.$store.getters.reservoirTendency
      if(reservoirTendency){
        let yesterday = reservoirTendency[0]
        let daybeforeyesterday = reservoirTendency[1];
        let trend = '';
        if(yesterday && daybeforeyesterday){
          if(yesterday.valor === daybeforeyesterday.valor){
            trend = 'Estável';
          } else if(yesterday.valor > daybeforeyesterday.valor){
            trend = 'Subir';
          } else if(yesterday.valor < daybeforeyesterday.valor){
            trend = 'Descer';
          }
        }
        this.tendency = trend;
      }

      //accumulated rain in current month
      let accumulatedRainCurrentMonth = null;
      let lastUpdatedCurrentMonth = null;
      if (this.$store.getters.accumulatedRainCurrentMonth[0]) {
        accumulatedRainCurrentMonth = this.$store.getters.accumulatedRainCurrentMonth[0].precIntensityAccum;
        lastUpdatedCurrentMonth = this.$store.getters.accumulatedRainCurrentMonth[0].lastUpdated;
      }
      this.accumulatedRainOfMonth = {
        value: accumulatedRainCurrentMonth ? accumulatedRainCurrentMonth : '---',
        updated: lastUpdatedCurrentMonth ? moment(lastUpdatedCurrentMonth).tz('America/Sao_Paulo').format('DD/MM/YYYY') : '##/##/####'
      };

      //Accumulated rain of the last thirty days
      let accumulatedRainOfTheLastThirtyDays = null;
      let lastUpdatedOfTheLastThirtyDays = null;
      if (this.$store.getters.accumulatedRainOfTheLastThirtyDays[0]) {
        accumulatedRainOfTheLastThirtyDays = this.$store.getters.accumulatedRainOfTheLastThirtyDays[0].precIntensityAccum;
        lastUpdatedOfTheLastThirtyDays = this.$store.getters.accumulatedRainOfTheLastThirtyDays[0].lastUpdated;
      }
      this.accumulatedOfLastThirtyDays = {
        value: accumulatedRainOfTheLastThirtyDays ? accumulatedRainOfTheLastThirtyDays : '---',
        updated: lastUpdatedOfTheLastThirtyDays ? moment(lastUpdatedOfTheLastThirtyDays).tz('America/Sao_Paulo').format('DD/MM/YYYY') : '##/##/####'
      };

      this.sensor351Data = undefined;
      this.rulerImageInfo = undefined;

      this.loading = false;
    },
    async loadUsefulStorage(){
      // armazenamento útil (%) só é exibido para o Miringuava; sensor 187 = volume (294) / VOLUME_UTIL, em fração (pode passar de 1)
      if (this.reservoirSelected.codigo !== 25644908) {
        this.usefulStorage = null;
        return;
      }
      try {
        const response = await loadDailySummary({
          date_start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
          date_end: moment().format('YYYY-MM-DD'),
          operation_ids: '1',
          sensor_ids: '187',
          sort: 'desc',
          station_ids: this.reservoirSelected.codigo,
        });
        const last = response.data && response.data[0];
        const value = last ? parseFloat(last.valor) : NaN;
        this.usefulStorage = Number.isFinite(value) ? {
          value: value * 100,
          updated: moment(last.data, 'YYYY-MM-DD').tz('America/Sao_Paulo').format('DD/MM/YYYY'),
        } : null;
      } catch (error) {
        this.usefulStorage = null;
      }
    },
    loadAnimationComplete(){
      this.showAnimation = this.loading;
    },
  }
}
</script>
<style scoped>
.last.v-card.v-sheet.theme--dark {
  min-height: 175px;
  min-width: 352px;
  max-height: 300px;
  max-width: 1000px;
}
.default.v-card.v-sheet.theme--dark {
  min-height: 285px;
  min-width: 150px;
  max-height: 350px;
  max-width: 350px;
}
</style>
